AFRAME.registerComponent('banner-uv-fix', {
    init: function () {
        this.applyFix = this.applyFix.bind(this);
        this.el.addEventListener('componentchanged', (evt) => {
            if (evt.detail.name === 'rounded-plane') {
                this.applyFix();
            }
        });
        if (this.el.components['rounded-plane']) {
            this.applyFix();
        }
    },
    applyFix: function () {
        const mesh = this.el.getObject3D('mesh');
        if (!mesh) return;

        const planeMesh = mesh.children ? mesh.children.find(c => c.type === 'Mesh') : (mesh.type === 'Mesh' ? mesh : null);
        if (!planeMesh || !planeMesh.geometry) return;

        const data = this.el.getAttribute('rounded-plane');
        if (!data) return;

        const pos = planeMesh.geometry.attributes.position;
        if (!pos) return;

        const uvs = new Float32Array(pos.count * 2);
        for (let i = 0; i < pos.count; i++) {
            uvs[i * 2] = pos.getX(i) / data.width;
            uvs[i * 2 + 1] = pos.getY(i) / data.height;
        }
        planeMesh.geometry.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));
        planeMesh.geometry.attributes.uv.needsUpdate = true;
    }
});

(function () {
    const ROTATION_INTERVAL_MS = 60000;
    
    const SLOTS = [
        { id: 'left', position: "-2.420 1.475 -1.9", rotation: "0 0 0", visible: true },
        { id: 'right', position: "2.420 1.475 -1.9", rotation: "0 0 0", visible: true },
        { id: 'hidden', position: "0 1.475 5", rotation: "0 0 0", visible: false }
    ];

    let bannerEntities = [];
    let currentMapping = [0, 1, 2];

    function init() {
        const b1 = document.getElementById('left-banner');
        const b2 = document.getElementById('right-banner');
        const b3 = document.getElementById('hidden-banner');

        if (!b1 || !b2 || !b3) {
            console.warn('[VRBanners] Not all banners found, retrying...');
            setTimeout(init, 1000);
            return;
        }

        bannerEntities = [b1, b2, b3];
                
        const toWatchlistBtn = document.getElementById('banner-to-watchlist');
        if (toWatchlistBtn) {
            toWatchlistBtn.addEventListener('click', async () => {
                if (window.WatchlistApp && window.WatchlistApp.Manager) {
                    const auth = await window.WatchlistApp.Manager.checkAuthorization();
                    
                    if (auth.authorized) {
                        const watchlistBtn = document.querySelector('[chart-type-control] [data-action="watchlist-reports"]');
                        if (watchlistBtn) {
                            watchlistBtn.click();
                        } else {
                            console.error('[VRBanners] Watchlist button not found in chart-type-control');
                        }
                    } else {
                        if (window.AuthUI && window.AuthUI.showAuthModal) {
                            window.AuthUI.showAuthModal();
                        } else {
                            console.warn('[VRBanners] AuthUI.showAuthModal not available');
                        }
                    }
                }
            });
        }

        const toWebsiteBtn = document.getElementById('banner-to-website');
        if (toWebsiteBtn) {
            toWebsiteBtn.addEventListener('click', () => {
                const scene = document.querySelector('a-scene');
                if (scene && scene.exitVR) {
                    scene.exitVR();
                }
                window.location.href = 'desktop.html';
            });
        }

        const toNewsBtn = document.getElementById('banner-to-news');
        if (toNewsBtn) {
            toNewsBtn.addEventListener('click', () => {
                const btnNews = document.getElementById('top-nav-news-btn');
                if (btnNews) {
                    btnNews.click();
                } else {
                    const topMenuControls = document.querySelector('[top-menu-controls]');
                    if (topMenuControls && topMenuControls.components['top-menu-controls']) {
                        topMenuControls.components['top-menu-controls'].setTopFrameSelection('news');
                    }
                    if (window.renderStockChartByAction) {
                        window.renderStockChartByAction('news-graph', 'gen');
                    }
                    const scene = document.querySelector('a-scene');
                    if (scene) {
                        scene.emit('chart-type-changed', { action: 'news-graph' });
                    }
                }
            });
        }

        setInterval(rotate, ROTATION_INTERVAL_MS);
    }

    function rotate() {
        // Rotation: 
        // Banner in Slot 0 (Left) -> Slot 2 (Hidden)
        // Banner in Slot 1 (Right) -> Slot 0 (Left)
        // Banner in Slot 2 (Hidden) -> Slot 1 (Right)
        
        const newMapping = [];
        for (let i = 0; i < currentMapping.length; i++) {
            const currentSlotIdx = currentMapping[i];
            let nextSlotIdx;
            if (currentSlotIdx === 0) nextSlotIdx = 2;
            else if (currentSlotIdx === 1) nextSlotIdx = 0;
            else if (currentSlotIdx === 2) nextSlotIdx = 1;
            
            newMapping[i] = nextSlotIdx;
        }
        currentMapping = newMapping;

        bannerEntities.forEach((entity, bannerIdx) => {
            const slotIdx = currentMapping[bannerIdx];
            const slot = SLOTS[slotIdx];
            
            entity.setAttribute('position', slot.position);
            entity.setAttribute('rotation', slot.rotation);
            entity.setAttribute('visible', slot.visible);
        });
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        init();
    } else {
        window.addEventListener('DOMContentLoaded', init);
    }
})();
